type OutputComboProps = {
  title?: string;
  info?: string;
  bottomText?: string;
  bottomClassName?: string;
  bigValue?: string;
  topValue?: string;
  smallValue?: string;
  hasDivide?: Boolean;
  className?: string;
  small?: Boolean;
};

export default function OutputCombo({
  title,
  info,
  bottomText,
  bottomClassName = "text-blue-600",
  bigValue = "",
  topValue = "",
  smallValue,
  hasDivide,
  className,
  small,
}: OutputComboProps) {
  return (
    <section className={className}>
      <div
        className={`text-sm text-gray-500`}
      >
        {title ? (
          <div
            className={`${
              bottomText ? "font-bold " : ""
            }py-1 flex justify-between`}
          >
            <div className={`text-xs text-gray-500 w-full pb-2 mb-0.5 ${
              hasDivide ? "border-b border-gray-100" : ""
            }`}>{title}</div>
            <div className="text-blue-600 text-base whitespace-nowrap">{topValue}</div>
          </div>
        ) : null}
        <div className="flex justify-between">
          <div
            className={`${bottomText ? "" : "font-['Avenir-Bold'] tracking-tight"} ${
              small ? "" : "text-xl"
            } ${bottomClassName}`}
          >
            {bottomText ? bottomText : <div dangerouslySetInnerHTML={{__html: bigValue}} />}
          </div>
          <div className={`${bottomText || (!bottomText && !topValue) ? "text-blue-600 mt-0.5 text-xs" : "text-xs text-gray-400 -mt-2 mb-2"} tracking-wide`}>
            {smallValue}
          </div>
        </div>
      </div>
    </section>
  );
}
